import http from "../../../core/services/http.service";
import {AppSettings} from "../../../shared/AppSettings";

const BranchService = {
  getBranches(params = null) {
    return http.get('/api/v1/branches/', {params});
  },

  getBranch(id) {
    return http.get(`/api/v1/branches/${id}`);
  },

  updateBranch(id, data, expand = '') {
    return http.put(`/api/v1/branches/${id}/?expand=${expand}`, data);
  },

  createBranch(data, expand = '') {
    return http.post(`/api/v1/branches/?expand=${expand}`, data);
  },

  removeBranch(uuid) {
    return http.delete(`/api/v1/branches/${uuid}`)
  },

  postBranchesOnWebsite() {
    return http.post(`/api/v1/branches/website-sync/`);
  },

  updateItemLocation(uuid, data, expand = '') {
    return http.patch(`/api/v1/branches/item-locations/${uuid}/?expand=${expand}`, data);
  },

  createItemLocation(data, expand = '') {
    return http.post(`/api/v1/branches/item-locations/?expand=${expand}`, data);
  },

  removeItemLocation(uuid) {
    return http.delete(`/api/v1/branches/item-locations/${uuid}/`)
  },

  removeClerk(uuid) {
    return http.delete(`/api/v1/branches/clerks/${uuid}/`)
  },
  createClerk(data,expand) {
    return http.post(`/api/v1/branches/clerks/?expand=${expand}`, data);
  },
  updateClerk(uuid, data, expand = '') {
    return http.put(`/api/v1/branches/clerks/${uuid}/?expand=${expand}`, data);
  },
  createLanguage(data,expand) {
    return http.post(`/api/v1/branches/languages/?expand=${expand}`, data);
  },
  updateLanguage(uuid, data, expand = '') {
    return http.put(`/api/v1/branches/languages/${uuid}/?expand=${expand}`, data);
  },
  removeLanguage(uuid) {
    return http.delete(`/api/v1/branches/languages/${uuid}/`)
  },
  getItemLocationUrlForQrCode(branchUuid, itemLocationUuid) {
    return `${AppSettings.portalUrl()}/branches/${branchUuid}/item-locations/${itemLocationUuid}`;
  },
  getCharges() {
    return http.get('api/v1/finances/charges/');
  },
  createTrustLevel(data) {
    return http.post(`/api/v1/branches/trust-levels/`, data);
  },
  updateTrustLevel(uuid, data) {
    return http.put(`/api/v1/branches/trust-levels/${uuid}/`, data);
  },
  removeTrustLevel(uuid) {
    return http.delete(`/api/v1/branches/trust-levels/${uuid}/`)
  },
};

export default BranchService;
